import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { XDialog } from '@adornis/dialog/x-dialog.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { LogistikRoutes } from '@chancenlogistik/client/routes.js';
import { LogistikProduct } from '@chancenwerk/db/LogistikProduct.js';
import '@chancenwerk/design/components/cr-button.js';
import '@chancenwerk/design/components/cr-flex.js';
import '@chancenwerk/design/components/fonts.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * @customElement logistik-dialog-item-added-to-cart
 */
@customElement('logistik-dialog-item-added-to-cart')
export class LogistikDialogItemAddedToCart extends XDialog<void> {
  static override get element_name() {
    return 'logistik-dialog-item-added-to-cart';
  }

  @property() public product = new RXController(this, new LogistikProduct({}));
  @property() public quantity = new RXController(this, 0);
  @property() public backRoute = new RXController(this, '/');

  override render() {
    return html`
      <cr-flex space="md" padding="lg">
        <cr-text>
          <b>${this.quantity.value}x ${this.product.value.title} </b> erfolgreich zum Warenkorb hinzugefügt
        </cr-text>
        <cr-flex horizontal space="md" crossaxis-center>
          <cr-button @click=${() => goTo(LogistikRoutes.cart)} mode="outline">Zum Warenkorb</cr-button>
          <cr-button @click=${() => goTo(this.backRoute.value)}>Weitere Produkte hinzufügen</cr-button>
        </cr-flex>
      </cr-flex>
    `;
  }
}
